import { render, staticRenderFns } from "./pagetitle.vue?vue&type=template&id=5dcb69e8&scoped=true&"
import script from "./pagetitle.vue?vue&type=script&lang=js&"
export * from "./pagetitle.vue?vue&type=script&lang=js&"
import style0 from "./pagetitle.vue?vue&type=style&index=0&id=5dcb69e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb69e8",
  null
  
)

export default component.exports